export const ADD_SEQUENCE = "ADD_SEQUENCE"
export const TYPE_TEXT_EL = 'TYPE_TEXT_EL'
export const ECHO = 'ECHO'
export const MESSAGE_BOX = 'MESSAGE_BOX'
export const GET_CLIPBOARD = 'GET_CLIPBOARD'
export const GET_ASSET = 'GET_ASSET'
export const GET_CREDENTIALS = 'GET_CREDENTIALS'
export const GET_PARAMETERS = 'GET_PARAMETERS'
export const READ = 'READ'
export const WAIT_ACTION = 'WAIT_ACTION'
export const HTTP = 'HTTP'
export const ASSIGN = 'ASSIGN'
export const ASK= "ASK"
export const ADD_EXTERNAL_FLOW = "ADD_EXTERNAL_FLOW"
export const CLICK_EL = 'CLICK_EL'
export const IFELSE = 'IFELSE'
export const IF = 'IF'
export const ELSEIF = 'ELSEIF'
export const TRY_CATCH =  "TRY_CATCH"
export const LOOPS = 'LOOPS'
export const STATEMENT = 'STATEMENT'
export const OCR = 'OCR'
export const CSV_HEADER = 'CSV_HEADER'
export const CSV_ROW = 'CSV_ROW'
export const STOP = "STOP"